export const Types = {
  NAVIGATE_TO: 'NAVIGATE_TO',
};

export const Actions = {
  navigateTo: route => ({
    route,
    type: Types.NAVIGATE_TO,
  }),
};



// WEBPACK FOOTER //
// ./src/redux/navigation/actions.js